import React from 'react';

interface ILoaderProps {
    loading: boolean;
    title?: string | string[];
    height?: number;
}

function Loader({ loading, title, height }: ILoaderProps) {
    const renderTitle = () => {
        const x = [];

        if (Array.isArray(title) && title.length > 0) {
            title.forEach((item) => {
                x.push(<b>{`${item}\n`}</b>);
            });
        }

        if (typeof title === 'string') {
            x.push(<b>{title}</b>);
        }

        return React.Children.toArray(x);
    };

    const classes = ['d-flex flex-column justify-content-center align-items-center'];

    if (typeof height === 'undefined') {
        classes.push('global-loader-container');
    }

    if (loading) {
        return (
            <div className={classes.join(' ')} style={{ height }}>
                <div className="spinner-border global-loader text-primary" role="status" />
                {(typeof title === 'string' || Array.isArray(title)) && (
                    <h6 className="text-primary mt-2 loader-title text-center">
                        {renderTitle()}
                    </h6>
                )}
            </div>
        );
    }
    return null;
}

Loader.defaultProps = {
    title: undefined,
    height: undefined,
};

export default Loader;
